import styled from 'styled-components';

export const FlexNotes = styled.div`
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;

  button {
    &:hover {
      color: var(--color-text-muted);
    }
  }
`;
